import { stationTypeMessages } from '@app/components/stations/station-messages';
import { Chip, ChipProps } from '@mui/material';
import { useIntl } from 'react-intl';
import { StationType as StationTypeEnum } from '@app/core/types/stations';

interface Props {
  readonly type: StationTypeEnum;
  readonly size?: ChipProps['size'];
}

export function StationType({ type, size }: Props) {
  const { formatMessage } = useIntl();
  const message = stationTypeMessages[type];
  const label = message ? formatMessage(message) : type;

  return <Chip label={label} size={size} />;
}
